export default __webpack_public_path__ + "380a942a3051277571fc5369289af212.png";